import { Button, ButtonLabel, Container } from './styles';

type Props = {
  selected: string;
  setSelected: any;
}

const buttons = [
  { label: 'Feed', icon: FeedIcon },
  { label: 'Snipz', icon: SnipzIcon },
  { label: 'Comunidade', icon: ComunidadeIcon },
  { label: 'Eventos', icon: EventosIcon },
]

export default function LeftFeedMenu({ selected, setSelected }: Props) {
  return (
    <Container>
      {buttons.map((button, index) => (
        <Button key={index} selected={button.label === selected} onClick={() => setSelected(button.label)}>
          <button.icon color={button.label === selected ? '#6E30E8' : '#4D4D4D'} />
          <ButtonLabel> {button.label} </ButtonLabel>
        </Button>
      ))}
    </Container>
  )
}

function FeedIcon({ color }: { color: string }) {
  // #4D4D4D
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13.667 6.68h.007M5.36 12.098l3.25-3.25c.67-.644 1.497-.644 2.167 0l3.61 3.612m-1.444-1.445l.723-.722c.67-.645 1.496-.645 2.166 0l1.806 1.805M11.5 3.07c6.5 0 6.5 0 6.5 6.5s0 6.5-6.5 6.5-6.5 0-6.5-6.5 0-6.5 6.5-6.5z"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        d="M17.001 19.07h-3.878M16.999 22.07h-4.505"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M8.141 22.54l1.661-1.628a1.062 1.062 0 00.003-1.523 1.112 1.112 0 00-1.551-.003l-.112.11-.11-.11a1.112 1.112 0 00-1.551-.003 1.063 1.063 0 00-.003 1.523l1.663 1.634z"
      ></path>
    </svg>
  );
}

function SnipzIcon({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke={color}
        d="M7.037 6.326a.5.5 0 01.758-.428l9.57 5.742a.5.5 0 010 .858l-9.57 5.742a.5.5 0 01-.758-.428V6.325z"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.371 4.234l-1.669 6.228 3.848 1.03-7.753 8.413 1.669-6.228-3.848-1.031 7.753-8.412z"
      ></path>
    </svg>
  );
}

function ComunidadeIcon({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 13.872L9.826 15.01a.392.392 0 01-.568-.41l.415-2.41-1.757-1.708a.389.389 0 01.217-.665l2.428-.352 1.087-2.193a.391.391 0 01.702 0l1.085 2.193 2.428.352a.39.39 0 01.217.665l-1.756 1.707.414 2.41a.39.39 0 01-.568.411L12 13.872z"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 4.9a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-.586 1.414c-.375.375-.593.272-1.123.62l-6.863 2.306-5.905-2.305c-.9-.548-.562-.246-.937-.621A2 2 0 014 16.9v-12z"
      ></path>
    </svg>
  );
}

function EventosIcon({ color }: { color: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12.5 21.07H6a2 2 0 01-2-2v-12a2 2 0 012-2h12a2 2 0 012 2v5m-4-9v4m-8-4v4m-4 4h16m-4 8a3 3 0 106 0 3 3 0 00-6 0z"
      ></path>
    </svg>
  );
}
